// src/components/discovery/ConfidenceFilters.jsx
import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Filter as FilterIcon } from "lucide-react";

export default function ConfidenceFilters({ filters, onFiltersChange, problemCount }) {
  const handleFilterChange = (key, value) => {
    onFiltersChange?.((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      <FilterIcon size={15} color="var(--fg-muted)" aria-hidden="true" />
      <Select value={filters.status} onValueChange={(v) => handleFilterChange("status", v)} style={{ width: 170 }}>
        <SelectTrigger aria-label="Status filter">
          <SelectValue placeholder="All statuses" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All statuses</SelectItem>
          <SelectItem value="discovery">Discovery</SelectItem>
          <SelectItem value="validated">Validated</SelectItem>
          <SelectItem value="solution_designed">Solution designed</SelectItem>
          <SelectItem value="in_roadmap">In roadmap</SelectItem>
          <SelectItem value="solved">Solved</SelectItem>
        </SelectContent>
      </Select>

      <Select value={filters.severity} onValueChange={(v) => handleFilterChange("severity", v)} style={{ width: 170 }}>
        <SelectTrigger aria-label="Severity filter">
          <SelectValue placeholder="All severities" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All severities</SelectItem>
          <SelectItem value="low">Low</SelectItem>
          <SelectItem value="medium">Medium</SelectItem>
          <SelectItem value="high">High</SelectItem>
          <SelectItem value="critical">Critical</SelectItem>
        </SelectContent>
      </Select>

      <Select value={filters.confidence} onValueChange={(v) => handleFilterChange("confidence", v)} style={{ width: 190 }}>
        <SelectTrigger aria-label="Confidence filter">
          <SelectValue placeholder="All confidence" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All confidence</SelectItem>
          <SelectItem value="low">Low (&lt;50%)</SelectItem>
          <SelectItem value="medium">Medium (50–79%)</SelectItem>
          <SelectItem value="high">High (80%+)</SelectItem>
        </SelectContent>
      </Select>

      <span className="tabular" style={{ marginLeft: "auto", fontSize: 12, color: "var(--fg-muted)" }}>
        {problemCount} {problemCount === 1 ? "problem" : "problems"}
      </span>
    </div>
  );
}
